'use client';

import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface IFormRowProps {
  label?: React.ReactNode;
  for?: string;
  value?: React.ReactNode;
  children?: React.ReactNode;
  description?: React.ReactNode;
  size?: 'default' | 'narrow';
  required?: boolean | string;
  hasError?: boolean | string;
}

const FormRow: React.FunctionComponent<IFormRowProps> = (props) => {
  return (
    <div
      className={classNames('form-row', {
        ['size-default']: props.size === 'default' || !props.size,
        ['size-narrow']: props.size === 'narrow',
        ['has-error']: !!props.hasError,
      })}
    >
      {props.label && (
        <div className={'form-row__label'}>
          {props.label && <label htmlFor={props.for}>{props.label}</label>}
          {props.required && (
            <span className={'form-row__label__required'}>{typeof props.required === 'boolean' ? '' : props.required} *</span>
          )}
        </div>
      )}
      {props.children && (
        <div className={'form-row__content'}>
          <div className={'form-row__content__items'}>{props.children}</div>
          {props.description && <div className={'form-row__content__description'}>{props.description}</div>}
          {typeof props.hasError === 'string' && <div className={'form-row__content__error'}>{props.hasError}</div>}
        </div>
      )}
      {props.value && <div className={'form-row__value'}>{props.value}</div>}
    </div>
  );
};

FormRow.displayName = 'FormRow';

export default FormRow;
